import React from 'react';
import ImageButton from 'components/customComponents/Controls/imageButton';
import { IStyle } from 'Styles';

export interface ActionContainerProps {
  onEditClick?: () => void;
  onDeleteClick?: () => void;
  onAddClick?: () => void;
  onCopyEmailClick?: () => void;
  disableModifyActions?: boolean;
  disableAddActions?: boolean;
  customStyle?: React.CSSProperties;
  disableOnDeleteClick?: boolean;
  disableOnAddClick?: boolean;
  customButton?: React.ReactNode;
}

const ActionContainer = (props: ActionContainerProps) => {
  const {
    disableOnDeleteClick = true,
    onAddClick,
    onDeleteClick,
    onEditClick,
    disableModifyActions,
    customStyle,
    disableOnAddClick,
    onCopyEmailClick,
    disableAddActions,
    customButton = null,
  } = props;

  return (
    <div id="actioncontainer-wrapper" style={{ ...sytles.root, ...customStyle }}>
      {onCopyEmailClick && (
        <ImageButton
          id="actioncontainer-copyemail-imagebutton"
          title="Copy Emails"
          iconName="email"
          onClick={onCopyEmailClick}
        />
      )}
      {onAddClick && (
        <ImageButton
          id="actioncontainer-add-imagebutton"
          iconName="add"
          onClick={onAddClick}
          disabled={disableAddActions || disableOnAddClick}
        />
      )}
      {onEditClick && (
        <ImageButton
          id="actioncontainer-edit-imagebutton"
          iconName="edit"
          onClick={onEditClick}
          disabled={disableModifyActions}
        />
      )}
      {onDeleteClick && (
        <ImageButton
          id="actioncontainer-delete-imagebutton"
          iconName="delete"
          onClick={onDeleteClick}
          disabled={disableOnDeleteClick}
        />
      )}
      {customButton}
    </div>
  );
};

const sytles: IStyle = {
  root: {
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
    gap: 5,
  },
};

export default ActionContainer;
